// extracted by css-extract-rspack-plugin
export default {"cls1":"RatingCard-cls1_11U","cls2":"RatingCard-cls2_Dqs RatingCard-cls1_11U"};